import React, { useEffect, useState } from "react";
import { Box, Fade, Typography } from "@mui/material";
import { CHATBOT_TEAL } from "./chatbotFormat";

const LOADING_STEPS = [
  "Fetching relevant tables",
  "Loading data",
  "Generating SQL query",
  "Preparing your answer",
];

const STEP_INTERVAL_MS = 1300;

const TypingDots = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          width: 5,
          height: 5,
          borderRadius: "50%",
          backgroundColor: CHATBOT_TEAL,
          animation: "chatbotTypingBounce 1.1s ease-in-out infinite",
          animationDelay: `${i * 0.16}s`,
          "@keyframes chatbotTypingBounce": {
            "0%, 60%, 100%": { transform: "translateY(0)", opacity: 0.5 },
            "30%": { transform: "translateY(-4px)", opacity: 1 },
          },
        }}
      />
    ))}
  </Box>
);

// Cycles through step labels every ~1.3s to mimic modern AI chat "thinking" states.
const ChatLoadingIndicator = () => {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    setStepIndex(0);
    const timer = setInterval(() => {
      setStepIndex((prev) => (prev < LOADING_STEPS.length - 1 ? prev + 1 : prev));
    }, STEP_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <TypingDots />
      <Fade in key={stepIndex} timeout={350}>
        <Typography
          sx={{
            fontSize: "12px",
            color: "var(--placeholder-color)",
            fontStyle: "italic",
            whiteSpace: "nowrap",
          }}
        >
          {LOADING_STEPS[stepIndex]}…
        </Typography>
      </Fade>
    </Box>
  );
};

export default ChatLoadingIndicator;
